import { ActionTypes, IAction } from "./types";

let INITIAL_STATE = {
  loading: false,
  error: null,
  data: [],
};

export default (state = INITIAL_STATE, action: IAction) => {
  switch (action.type) {
    case ActionTypes.LOADING:
      return {
        ...state, 
        loading: true
      };

    case ActionTypes.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case ActionTypes.ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
